module.exports = "/lucky-balls/img/btn-background-green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/btn-background-green.png
// module id = 98
// module chunks = 0